module.exports = __webpack_public_path__ + "static/img/icon_shop_address.f805d604.png";